var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 27.125C23.3337 25.3224 23.3337 24.4211 23.1327 23.6877C22.6803 22.0364 21.5131 20.7442 20.0217 20.2433C19.3592 20.0208 18.5451 20.0208 16.917 20.0208H11.0837C9.4555 20.0208 8.64142 20.0208 7.97899 20.2433C6.48752 20.7442 5.32037 22.0364 4.86794 23.6877C4.66699 24.4211 4.66699 25.3224 4.66699 27.125M19.2503 9.6875C19.2503 12.8977 16.8998 15.5 14.0003 15.5C11.1008 15.5 8.75033 12.8977 8.75033 9.6875C8.75033 6.47734 11.1008 3.875 14.0003 3.875C16.8998 3.875 19.2503 6.47734 19.2503 9.6875Z",
    stroke: "#237455",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser01);
export default __webpack_public_path__ + "static/media/user-01.905a65368e83d3e0fe2bf4e1d7f2e8fd.svg";
export { ForwardRef as ReactComponent };